import uuid from "react-uuid";

import { PRACTICE_SLUG } from "models";

export const FERTILIZER_BUNDLE_SLUGS = [PRACTICE_SLUG.MINERAL_FERTILIZERS, PRACTICE_SLUG.ORGANIC_FERTILIZERS];

export const TILLAGE_SEEDING_BUNDLE_SLUGS = [PRACTICE_SLUG.TILLAGES, PRACTICE_SLUG.SEEDINGS];

export const TILLAGE_BLANK_PRACTICE = (cropId: string) =>
  ({
    id: uuid(),
    key: Date.now().toString(),
    type: PRACTICE_SLUG.TILLAGES,
    endDate: "",
    cropId,
    assignedPracticeId: "",
    payout: 0,
    isConfirmed: false,
    year: 0,
  }) as const;
